var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"music-icon-box"},[(!_vm.activeOver && _vm.audioFile)?_c('button',{staticClass:"music-icon",class:_vm.musicPlay ? 'play' : '',on:{"click":_vm.playBgMusic}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }